export var ExportTMLOptions;
(function (ExportTMLOptions) {
    ExportTMLOptions["OBJECT_ONLY"] = "OBJECT_ONLY";
    ExportTMLOptions["OBJECT_WITH_DEPENDENCIES"] = "OBJECT_WITH_DEPENDENCIES";
})(ExportTMLOptions || (ExportTMLOptions = {}));
//# sourceMappingURL=ExportGroupTMLoptions.js.map